<template>
<div>

    <b-modal id="modal-1" title="Registro Nuevo Cliente" size="lg" hide-footer ref="my-modal">
        <div role="tablist">
            <b-card no-body class=mb-1>
                <b-card-header>
                    <b-button block v-b-toggle.accordion-0 variant="info">Ubicación Geográfica del Proyecto</b-button>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel">
                    <b-card-body>                        
                        <Map/>
                        

                        
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="info">Datos Cliente</b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <!--Formulario Datos Cliente inicio-->
                        <b-form>
                            <!-- <div>
                            <progress :value="UploadValue" max="100" id="uploader"></progress>
                            <button @click.prevent="onUpload">Upload</button>
                            <img width="320" :src="this.picture"/>
                        </div> -->
                            <b-form-group>

                            <b-button  @click.prevent="onPickFile" >Logotipo  </b-button>                            
                            <input 
                                type="file" 
                                style="display:none" 
                                ref="fileInput" 
                                accept="image/*"
                                @change="onFilePicked"
                                >
                                <img :src="imageUrl"  height="150">
                               <!--<b-form-input  v-model="selectedFile" type="file">Logo</b-form-input>-->
                            </b-form-group>


                            <b-form-group id="input-group-1" label="Nombre Proyecto   :" label-for="input-1">
                                <b-form-input id="input-1" v-model="nombre" type="text" required placeholder="Nombre Proyecto"></b-form-input>
                            </b-form-group>

                            <b-form-group id="input-group-2" label="Dirección   :" label-for="input-2">
                                <b-form-input id="input-2" v-model="direccion" required placeholder="Dirección"></b-form-input>
                            </b-form-group>

                            <b-form-group id="input-group-3" label="Valor fp   :" label-for="input-3" v-b-tooltip.hover title="Página 30 Reglamento-de-Autogeneracion-Distribuida-de-Ley-21118.pdf">
                                <b-form-select id="input-3" v-model="fp" :options="fpvalores" required show: true> </b-form-select> {{fp}}
                            </b-form-group>

                            <b-form-group id="input-group-4" label="Representante  :" label-for="input-4">
                                <b-form-input id="input-4" v-model="representante" type="text" required placeholder="Representante" max="100"></b-form-input>
                            </b-form-group>
                            <b-container class="bv-example-row">
                                <b-row>
                                    <b-col>
                                        <b-form-group id="input-group-5" label="Rut   :" label-for="input-5">
                                            <b-form-input id="input-5" v-model="rut" type="text" required placeholder="Ejemplo: 12345678-0" max="10" min="10"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="input-group-6" label="Teléfono :" label-for="input-6">
                                            <b-form-input id="input-6" v-model="telefono" type="number" required placeholder="998540025" max="12"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-form>
                        <!--Formulario Datos Cliente fin-->
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="info">Datos Distribuidora</b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body>

                        <b-form>
                            <b-form-group id="input-group-7" label="Distribuidora   :" label-for="input-7">
                                <b-form-select id="input-7" v-model="distribuidora" :options="distribuidoravalores" required show: true></b-form-select>
                            </b-form-group>
                            <b-container class="bv-example-row">
                                <b-row>
                                    <b-col>
                                        <b-form-group id="input-group-8" label="Potencia    :   " label-for="input-8">
                                            <b-form-input id="input-8" v-model="potencia" type="text" required placeholder="Potencia..."> </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="input-group-9" label="Tarifa    :   " label-for="input-9">
                                            <b-form-select id="input-9" v-model="tarifa" :options="tarifavalores" required show: true></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="input-group-10" label="Número Cliente    :   " label-for="input-10">
                                            <b-form-input id="input-10" v-model="numerocliente" type="text" required placeholder="Número Cliente"> </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-container>

                            <b-container class="bv-example-row">
                                <b-row>
                                    <b-col>
                                        <b-form-group id="input-group-11" label="Ultimo Costo CLP/KWh    :   " label-for="input-11">
                                            <b-form-input id="input-11" v-model="costoCLP_KWh" type="number" required placeholder="costoCLP/KWh"> </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="input-group-12" label="Ultimo Costo CLP/Transporte:    :   " label-for="input-12">
                                            <b-form-input id="input-12" v-model="costoCLP_transporte" type="number" required placeholder="Costo CLP/Transporte:"> </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="input-group-13" label="Precio CLP/Excedente     :   " label-for="input-13">
                                            <b-form-input id="input-13" v-model="precioCLP_excedente" type="number" required placeholder="Precio CLP/Excedente "> </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-form>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="info">Datos Detalle de Cuenta (MM)</b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                    <b-card-body>

                        <b-container class="bv-example-row">
                            <b-row v-if="boleta.length<12">

                                <p class="text-center"><strong> Mes - {{this.vmes}} Tarifa - {{tarifa}} </strong></p>
                                <table class="table table-sm">

                                    <div>
                                        <tr>
                                            <td>Kwh Consumo </td>
                                            <td><input type="text" v-model.number="kwconsumo"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo fijo mensual $/mes</td>
                                            <td><input type="number" id="idvar01" v-model.number="var01"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por uso del sistema de transmisión $/kWh</td>
                                            <td><input type="number" v-model.number="var02"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por servicio público $/mes</td>
                                            <td><input type="number" v-model.number="var03"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por energía $/kWh</td>
                                            <td><input type="number" v-model.number="var04"></td>
                                        </tr>
                                    </div>
                                    <div v-if="tarifa ==='BT1A'">
                                        <tr>
                                            <td>Cargo por compras de potencia $/kW</td>
                                            <td><input type="number" v-model.number="var05"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por compras de potencia en su componente de distribución $/kW</td>
                                            <td><input type="number" v-model.number="var06"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por potencia adicional de invierno en su componente de compras de potencia $/kW</td>
                                            <td><input type="number" v-model.number="var07"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por potencia adicional de invierno en su componente de distribución $/kW</td>
                                            <td><input type="number" v-model.number="var08"></td>
                                        </tr>
                                    </div>

                                    <div v-if="tarifa ==='BT1B'">
                                        <tr>
                                            <td>Cargo por potencia base en su componente de transmisión</td>
                                            <td><input type="number" v-model="var09"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por potencia base en su componente de distribución</td>
                                            <td><input type="number" v-model="var10"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por potencia de invierno</td>
                                            <td><input type="number" v-model="var11"></td>
                                        </tr>
                                    </div>

                                    <div v-if="tarifa ==='AT2' || tarifa==='BT2'">
                                        <tr>
                                            <td>Cargo por potencia contratada</td>
                                            <td><input type="number" v-model="var12"></td>
                                        </tr>
                                    </div>

                                    <div v-if="tarifa ==='AT3' || tarifa==='BT3'">
                                        <tr>
                                            <td>Cargo por demanda máxima de potencia leída</td>
                                            <td><input type="number" v-model="var13"></td>
                                        </tr>
                                    </div>

                                    <div v-if="tarifa ==='AT4.1' || tarifa==='BT4.1'">
                                        <tr>
                                            <td>Demanda máxima de potencia contratada en horas punta kW</td>
                                            <td><input type="number" v-model="vard14"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por demanda máxima de potencia contratada en horas punta $/kW</td>
                                            <td><input type="number" v-model="var14"></td>
                                        </tr>
                                        <tr>
                                            <td>Demanda máxima de potencia contratada kW</td>
                                            <td><input type="number" v-model="vard15"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por demanda máxima de potencia contratada $/kW</td>
                                            <td><input type="number" v-model="var15"></td>
                                        </tr>
                                    </div>

                                    <div v-if="tarifa ==='AT4.2' || tarifa==='BT4.2'">
                                        <tr>
                                            <td>Demanda máxima de potencia contratada kW</td>
                                            <td><input type="number" v-model="vard16"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por demanda máxima de potencia contratada $/kW</td>
                                            <td><input type="number" v-model="var16"></td>
                                        </tr>
                                        <tr>
                                            <td>Demanda máxima de potencia leída en horas punta kW</td>
                                            <td><input type="number" v-model="vard17"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por demanda máxima de potencia leída en horas punta $/kW</td>
                                            <td><input type="number" v-model="var17"></td>
                                        </tr>
                                    </div>

                                    <div v-if="tarifa ==='AT4.3' || tarifa==='BT4.3'">
                                        <tr>
                                            <td>Demanda máxima de potencia leída en horas punta kW</td>
                                            <td><input type="number" v-model="vard18"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por demanda máxima de potencia leída en horas punta $/kW </td>
                                            <td><input type="number" v-model="var18"></td>
                                        </tr>
                                        <tr>
                                            <td>Demanda máxima de potencia suministrada kW</td>
                                            <td><input type="number" v-model="vard19"></td>
                                        </tr>
                                        <tr>
                                            <td>Cargo por demanda máxima de potencia suministrada $/KW</td>
                                            <td><input type="number" v-model="var19"></td>
                                            <td>Valor unitario</td>
                                        </tr>

                                    </div>
                                </table>

                            </b-row>
                            <div>
                                <p></p>
                            </div>
                            <div v-show="boleta.length<12" class="text-right">
                                <button @click.prevent="grabaritemsconsumo" class="btn  btn-info mx-2 " data-toggle="tooltip" data-placement="top" title="Registrar Data Mensual"><i class="fas fa-plus-circle"></i></button>
                                <!-- <button v-if="consumo.length>0" @click.prevent="borraritems('C')" data-toggle="tooltip" data-placement="top" title="Eliminar Datos" class="btn  btn-danger mx-2" ><i class="far fa-trash-alt"></i></button> -->
                            </div>

                            <!--Mostrar tabla de consumo una vez cargado los 12 valores y mostrar las sumas de Energía Transporte y Otros-->
                            <div v-show="boleta.length>=12">
                                <b-table small hover :items="boleta" :fields="fieldsc" class="text-right">
                                    <template v-slot:cell(otros)="data">
                                        <div v-if="tarifa ==='BT1A'">
                                            {{ data.item.cargoTarifario_05+data.item.cargoTarifario_06+data.item.cargoTarifario_07+data.item.cargoTarifario_08 | formato }}
                                        </div>
                                        <div v-if="tarifa ==='BT1B'">
                                            {{ data.item.cargoTarifario_09+data.item.cargoTarifario_10+data.item.cargoTarifario_11 | formato }}
                                        </div>
                                        <div v-if="tarifa ==='AT2' || tarifa==='BT2'">
                                            {{ data.item.cargoTarifario_12| formato }}
                                        </div>
                                        <div v-if="tarifa ==='AT3' || tarifa==='BT3'">
                                            {{ data.item.cargoTarifario_13 | formato }}
                                        </div>
                                        <div v-if="tarifa ==='AT4.1' || tarifa==='BT4.1'">
                                            {{ data.item.cargoTarifario_14+data.item.cargoTarifario_15 | formato }}
                                        </div>
                                        <div v-if="tarifa ==='AT4.2' || tarifa==='BT4.2'">
                                            {{ data.item.cargoTarifario_16+data.item.cargoTarifario_17 | formato }}
                                        </div>
                                        <div v-if="tarifa ==='AT4.3' || tarifa==='BT4.3'">
                                            {{ data.item.cargoTarifario_18+data.item.cargoTarifario_19 | formato }}
                                        </div>
                                    </template>
                                </b-table>

                                <div class="bg-info">
                                    <table class="table table-sm text-right">
                                        <tr>
                                            <td>Tot</td>
                                            <td>{{totalkwc | formato2}}</td>
                                            <td>{{totalclpe | formato}}</td>
                                            <td>{{totalclpt | formato}}</td>
                                            <td>{{totalclpo | formato}}</td>
                                        </tr>
                                    </table>
                                </div>

                            </div>
                            <!--Mostrar tabla de consumo una vez cargado los 12 valores -->
                        </b-container>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-4 variant="info">Datos Aporte Solar</b-button>
                </b-card-header>
                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                    <b-card-body>

                        <b-container class="bv-example-row">
                            <b-row class="tamano1" v-if="aporte.length<12">
                                <b-col cols="3" class="text-left">
                                    Mes
                                </b-col>
                                <b-col cols="3" class="text-right">
                                    Kw <input v-model.number="kwa" id="kwa" size="2" maxlength="7">
                                </b-col>
                            </b-row>
                            <div>
                                <p></p>
                            </div>
                            <div class="text-center">
                                <button @click.prevent="grabaritemsaporte" class="btn  btn-info mx-2"><i class="fas fa-plus-circle"></i></button>
                                <button v-if="aporte.length>0" @click.prevent="borraritems('A')" data-toggle="tooltip" data-placement="top" title="Eliminar Datos" class="btn  btn-danger mx-2"><i class="far fa-trash-alt"></i></button>
                            </div>
                            <div>
                                <p></p>
                            </div>
                        </b-container>

                        <div>
                            <b-container class="bv-example-row">
                                <b-row class="tamano1" v-for="(itema,index) in aporte" :key="index">
                                    <b-col cols="3" class="text-left">{{itema.mes }}</b-col>
                                    <b-col cols="3" class="text-right">{{itema.elemento1a | formato2}}</b-col>
                                </b-row>
                                <b-row class="tamano1">
                                    <b-col cols="3" class="text-left"><strong>{{aporte.length}} Total </strong></b-col>
                                    <b-col cols="3" class="text-right"><strong>{{sumaelemento1a| formato2 }}</strong></b-col>
                                </b-row>
                            </b-container>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" v-if="boleta.length===12 && aporte.length===12">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-5 variant="info"><i class="fas fa-plus-circle"> Guardar Registro</i></b-button>
                </b-card-header>
                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <div class="text-center">
                            <p>Si ya ha transcrito los datos del cliente puede hacer clicl en el siguiente botón para guardar</p>
                            <button @click="grabar_registro" class="btn btn-info">Grabar Registro</button>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>

        </div>
    </b-modal>

</div>
</template>

<script>
import Swal from 'sweetalert2';
import accouting from 'accounting';
import Map from '../components/Map';
//import firebase from 'firebase';

export default {
    name: 'ModalAgregarcliente',
    components:{
        Map
    },
    data() {
        return {
            imageUrl:'',
            UploadValue:0,
            selectedFile:null,
            currentNumber:0,
            timer:null,
            picture:null,
            fieldsc: [{
                    key: 'mes',
                    label: 'Mes',
                    //sortable: true,
                },
                {
                    key: 'kwconsumo',
                    label: 'kWh',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 0, '.', ',');
                    }
                },
                {
                    key: 'cargoTarifario_04',
                    label: '$Energía',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                },
                {
                    key: 'cargoTarifario_02',
                    label: '$Transporte',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                },
                {
                    key: 'otros',
                    label: '$Otros',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                }
            ],
            nombre: '',
            direccion: '',
            fp: null,
            fpvalores: {},
            representante: '',
            rut: '',
            telefono: '',
            status: 'Propuesta',
            distribuidora: null,
            distribuidoravalores: [],
            potencia: '',
            tarifa: '',
            tarifavalores: [],
            numerocliente: '',
            costoCLP_KWh: 0,
            costoCLP_transporte: 0,
            precioCLP_excedente: 0,
            consumo: [],
            aporte: [],
            vmes: 'Ene',
            contador: 1,
            contador2: 1,
            kwc: '',
            energia: '',
            transporte: '',
            otros: '',
            kwa: '',
            sumaelemento1: 0,
            sumaelemento2: 0,
            sumaelemento3: 0,
            sumaelemento4: 0,
            sumaelemento1a: 0,
            img: 'https://firebasestorage.googleapis.com/v0/b/cursosaudicont.appspot.com/o/LOGO%20EMPRESA.jpg?alt=media&token=d0951a3d-b049-4deb-a16f-f79292b4e66a',

            varmes: 'Ene',
            var01: '',
            var02: '',
            var03: '',
            var04: '',
            var05: '',
            var06: '',
            var07: '',
            var08: '',
            var09: '',
            var10: '',
            var11: '',
            var12: '',
            var13: '',
            var14: '',
            var15: '',
            var16: '',
            var17: '',
            var18: '',
            var19: '',
            vard14: '',
            vard15: '',
            vard16: '',
            vard17: '',
            vard18: '',
            vard19: '',
            boleta: [],
            kwconsumo: '',
            totalkwc: 0,
            totalclpe: 0,
            totalclpt: 0,
            totalclpo: 0,
            //  17/092020 para registrar aqui mismo DMPS DMPSHP  y el MÉTODO operacionesDMPS()
            arreglotemporal: [],
            kesimomayor1: 0,
            kesimomayor2: 0,
            DMPS: [],
            kwtabulado1Doble: [],
            kwtabulado1: [],
            mesesIniciales: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            mesesabrsep: [0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0], // ENTRE 18:00 A 22:00 HORAS SOLAMENTE. Y SE EJECUTA LECTURA ENTRE ABRIL Y SEPTIEMBRE

        }
    },
    methods: {
        onPickFile(){            
            this.$refs.fileInput.click()
        },
        onFilePicked(event){
            const files = event.target.files
            let filename = files[0].name;
            if (filename.lastIndexOf('.')<=0){
                return alert('Selecciones un archivo válido')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load',() => {
                this.imageUrl = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0]            
        },



/*         onFileSelected(event){
            this.selectedFile = event.target.files[0];
        },
        onUpload(){
            const storageRef=firebase.storage().ref(`/imagenes/${this.selectedFile.name}`);
            const task = storageRef.put(this.selectedFile);
            task.on('state_changed', snapshot => {
                let percentage =(snapshot.bytesTransferred/snapshot.totalBytes)*100;
                this.UploadValue = percentage;
            }, error=>{console.log(error.message)},
                ()=>{this.UploadValue=100;
                    task.snapshot.ref.getDownloadURL().then((url)=> {
                        this.picture = url;
                        console.log(this.picture)
                    });             
            })
        },
 */

        grabaritemsconsumo() {
            if (this.tarifa === "BT1A") {
                let auxiliarboleta = {
                    mes: this.vmes,
                    kwconsumo: parseFloat(this.kwconsumo),
                    cargoTarifario_01: parseFloat(this.var01),
                    cargoTarifario_02: parseFloat(this.var02),
                    cargoTarifario_03: parseFloat(this.var03),
                    cargoTarifario_04: parseFloat(this.var04),
                    cargoTarifario_05: parseFloat(this.var05),
                    cargoTarifario_06: parseFloat(this.var06),
                    cargoTarifario_07: parseFloat(this.var07),
                    cargoTarifario_08: parseFloat(this.var08),
                }
                this.boleta.push(auxiliarboleta);
                this.contador++;
                this.totalkwc += this.kwconsumo; //sumakwconsumo 
                this.totalclpe += parseFloat(this.var02); //sumaenergia
                this.totalclpt += parseFloat(this.var04); //sumatransporte
                this.totalclpo += (parseFloat(this.var05) + parseFloat(this.var06) + parseFloat(this.var07) + parseFloat(this.var08)); //sumaotros
                this.kwconsumo = '';
                this.var01 = '';
                this.var02 = '';
                this.var03 = '';
                this.var04 = '';
                this.var05 = '';
                this.var06 = '';
                this.var07 = '';
                this.var08 = '';

                if (this.contador === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador === 5) {
                    this.vmes = 'May'
                } else if (this.contador === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                document.getElementById('idvar01').focus();
            }
            if (this.tarifa === "BT1B") {
                let auxiliarboleta = {
                    mes: this.vmes,
                    kwconsumo: parseFloat(this.kwconsumo),
                    cargoTarifario_01: parseFloat(this.var01),
                    cargoTarifario_02: parseFloat(this.var02),
                    cargoTarifario_03: parseFloat(this.var03),
                    cargoTarifario_04: parseFloat(this.var04),
                    cargoTarifario_09: parseFloat(this.var09),
                    cargoTarifario_10: parseFloat(this.var10),
                    cargoTarifario_11: parseFloat(this.var11),
                }
                this.boleta.push(auxiliarboleta);
                this.contador++;
                this.totalkwc += this.kwconsumo; //sumakwconsumo 
                this.totalclpe += parseFloat(this.var02); //sumaenergia
                this.totalclpt += parseFloat(this.var04); //sumatransporte
                this.totalclpo += (parseFloat(this.var09) + parseFloat(this.var10) + parseFloat(this.var11)); //sumaotros
                this.kwconsumo = '';
                this.var01 = '';
                this.var02 = '';
                this.var03 = '';
                this.var04 = '';
                this.var09 = '';
                this.var10 = '';
                this.var11 = '';

                if (this.contador === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador === 5) {
                    this.vmes = 'May'
                } else if (this.contador === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                document.getElementById('idvar01').focus();
            }
            if (this.tarifa === "AT2" || this.tarifa === 'BT2') {
                let auxiliarboleta = {
                    mes: this.vmes,
                    kwconsumo: parseFloat(this.kwconsumo),
                    cargoTarifario_01: parseFloat(this.var01),
                    cargoTarifario_02: parseFloat(this.var02),
                    cargoTarifario_03: parseFloat(this.var03),
                    cargoTarifario_04: parseFloat(this.var04),
                    cargoTarifario_12: parseFloat(this.var12),
                }
                this.boleta.push(auxiliarboleta);
                this.contador++;
                this.totalkwc += this.kwconsumo; //sumakwconsumo 
                this.totalclpe += parseFloat(this.var02); //sumaenergia
                this.totalclpt += parseFloat(this.var04); //sumatransporte
                this.totalclpo += (parseFloat(this.var12)); //sumaotros
                this.kwconsumo = '';
                this.var01 = '';
                this.var02 = '';
                this.var03 = '';
                this.var04 = '';
                this.var12 = '';

                if (this.contador === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador === 5) {
                    this.vmes = 'May'
                } else if (this.contador === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                document.getElementById('idvar01').focus();
            }
            if (this.tarifa === "AT3" || this.tarifa === 'BT3') {
                let auxiliarboleta = {
                    mes: this.vmes,
                    kwconsumo: parseFloat(this.kwconsumo),
                    cargoTarifario_01: parseFloat(this.var01),
                    cargoTarifario_02: parseFloat(this.var02),
                    cargoTarifario_03: parseFloat(this.var03),
                    cargoTarifario_04: parseFloat(this.var04),
                    cargoTarifario_13: parseFloat(this.var13),
                }
                this.boleta.push(auxiliarboleta);
                this.contador++;
                this.totalkwc += this.kwconsumo; //sumakwconsumo 
                this.totalclpe += parseFloat(this.var02); //sumaenergia
                this.totalclpt += parseFloat(this.var04); //sumatransporte
                this.totalclpo += (parseFloat(this.var13)); //sumaotros
                this.kwconsumo = '';
                this.var01 = '';
                this.var02 = '';
                this.var03 = '';
                this.var04 = '';
                this.var13 = '';

                if (this.contador === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador === 5) {
                    this.vmes = 'May'
                } else if (this.contador === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                document.getElementById('idvar01').focus();
            }
            if (this.tarifa === "AT4.1" || this.tarifa === 'BT4.1') {
                let auxiliarboleta = {
                    mes: this.vmes,
                    kwconsumo: parseFloat(this.kwconsumo),
                    cargoTarifario_01: parseFloat(this.var01),
                    cargoTarifario_02: parseFloat(this.var02),
                    cargoTarifario_03: parseFloat(this.var03),
                    cargoTarifario_04: parseFloat(this.var04),
                    cargoTarifario_d14: parseFloat(this.vard14),
                    cargoTarifario_14: parseFloat(this.var14),
                    cargoTarifario_d15: parseFloat(this.vard15),
                    cargoTarifario_15: parseFloat(this.var15),
                }
                this.boleta.push(auxiliarboleta);
                this.contador++;
                this.totalkwc += this.kwconsumo; //sumakwconsumo 
                this.totalclpe += parseFloat(this.var02); //sumaenergia
                this.totalclpt += parseFloat(this.var04); //sumatransporte
                this.totalclpo += (parseFloat(this.var14) + parseFloat(this.var15)); //sumaotros
                this.kwconsumo = '';
                this.var01 = '';
                this.var02 = '';
                this.var03 = '';
                this.var04 = '';
                this.vard14 = '';
                this.var14 = '';
                this.vard15 = '';
                this.var15 = '';

                if (this.contador === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador === 5) {
                    this.vmes = 'May'
                } else if (this.contador === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                document.getElementById('idvar01').focus();
            }
            if (this.tarifa === "AT4.2" || this.tarifa === 'BT4.2') {
                let auxiliarboleta = {
                    mes: this.vmes,
                    kwconsumo: parseFloat(this.kwconsumo),
                    cargoTarifario_01: parseFloat(this.var01),
                    cargoTarifario_02: parseFloat(this.var02),
                    cargoTarifario_03: parseFloat(this.var03),
                    cargoTarifario_04: parseFloat(this.var04),
                    cargoTarifario_d16: parseFloat(this.vard16),
                    cargoTarifario_16: parseFloat(this.var16),
                    cargoTarifario_d17: parseFloat(this.vard17),
                    cargoTarifario_17: parseFloat(this.var17),
                }
                this.boleta.push(auxiliarboleta);
                this.contador++;
                this.totalkwc += this.kwconsumo; //sumakwconsumo 
                this.totalclpe += parseFloat(this.var02); //sumaenergia
                this.totalclpt += parseFloat(this.var04); //sumatransporte
                this.totalclpo += (parseFloat(this.var16) + parseFloat(this.var17)); //sumaotros
                this.kwconsumo = '';
                this.var01 = '';
                this.var02 = '';
                this.var03 = '';
                this.var04 = '';
                this.vard16 = '';
                this.var16 = '';
                this.vard17 = '';
                this.var17 = '';

                if (this.contador === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador === 5) {
                    this.vmes = 'May'
                } else if (this.contador === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                document.getElementById('idvar01').focus();
            }
            if (this.tarifa === "AT4.3" || this.tarifa === 'BT4.3') {
                let auxiliarboleta = {
                    mes: this.vmes,
                    kwconsumo: parseFloat(this.kwconsumo),
                    cargoTarifario_01: parseFloat(this.var01),
                    cargoTarifario_02: parseFloat(this.var02),
                    cargoTarifario_03: parseFloat(this.var03),
                    cargoTarifario_04: parseFloat(this.var04),
                    cargoTarifario_d18: parseFloat(this.vard18),
                    cargoTarifario_18: parseFloat(this.var18),
                    cargoTarifario_d19: parseFloat(this.vard19),
                    cargoTarifario_19: parseFloat(this.var19),
                }
                this.boleta.push(auxiliarboleta);
                this.contador++;
                this.totalkwc += this.kwconsumo; //sumakwconsumo 
                this.totalclpe += parseFloat(this.var02); //sumaenergia
                this.totalclpt += parseFloat(this.var04); //sumatransporte
                this.totalclpo += (parseFloat(this.var18) + parseFloat(this.var19)); //sumaotros
                this.kwconsumo = '';
                this.var01 = '';
                this.var02 = '';
                this.var03 = '';
                this.var04 = '';
                this.vard18 = '';
                this.var18 = '';
                this.vard19 = '';
                this.var19 = '';

                if (this.contador === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador === 5) {
                    this.vmes = 'May'
                } else if (this.contador === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                document.getElementById('idvar01').focus();
            }
            //console.log(this.boleta)

        },
        grabaritemsaporte() {
            if (this.contador2 <= 12 && this.kwa > 0) {
                if (this.contador2 === 1) {
                    this.vmes = 'Ene'
                } else if (this.contador2 === 2) {
                    this.vmes = 'Feb'
                } else if (this.contador2 === 3) {
                    this.vmes = 'Mar'
                } else if (this.contador2 === 4) {
                    this.vmes = 'Abr'
                } else if (this.contador2 === 5) {
                    this.vmes = 'May'
                } else if (this.contador2 === 6) {
                    this.vmes = 'Jun'
                } else if (this.contador2 === 7) {
                    this.vmes = 'Jul'
                } else if (this.contador2 === 8) {
                    this.vmes = 'Ago'
                } else if (this.contador2 === 9) {
                    this.vmes = 'Sep'
                } else if (this.contador2 === 10) {
                    this.vmes = 'Oct'
                } else if (this.contador2 === 11) {
                    this.vmes = 'Nov'
                } else {
                    this.vmes = 'Dic'
                }
                let auxiliaraporte = {
                    mes: this.vmes,
                    elemento1a: parseFloat(this.kwa),
                }
                this.aporte.push(auxiliaraporte);
                this.contador2++;
                this.sumaelemento1a = parseFloat(this.sumaelemento1a) + parseFloat(this.kwa);
                this.kwa = '';
                document.getElementById('kwa').focus();
            }
        },
        grabar_registro() {
            if (this.nombre.length === 0) {
                Swal.fire("Escriba Nombre del Proyecto")
            } else if (this.direccion.length === 0) {
                Swal.fire('Escriba Direccion ')
            } else if (this.fp === null) {
                Swal.fire('Escriba fp ')
            } else if (this.representante.length === 0) {
                Swal.fire('Escriba Representante ')
            } else if (this.rut.length === 0) {
                Swal.fire('Escriba Rut ')
            } else if (this.telefono.length === 0) {
                Swal.fire('Escriba Telefono ')
            } else if (this.distribuidora.length === 0) {
                Swal.fire('Escriba Distribuidora ')
            } else if (this.potencia.length === 0) {
                Swal.fire('Escriba Potencia ')
            } else if (this.tarifa === null) {
                Swal.fire('Escriba Tarifa ')
            } else if (this.numerocliente.length === 0) {
                Swal.fire('Escriba Número Cliente ')
            } else if (this.costoCLP_KWh.length === 0) {
                Swal.fire('Escriba CostoCLP_KWh')
            } else if (this.costoCLP_transporte.length === 0) {
                Swal.fire('Escriba CostoCLP_Transporte')
            } else if (this.precioCLP_excedente.length === 0) {
                Swal.fire('Escriba PrecioCLP_excedente')
            } else if (this.boleta.length != 12) {
                Swal.fire('Escriba Datos de Consumo Año')
            } else if (this.aporte.length != 12) {
                Swal.fire('Escriba Datos de Aporte Año')
            } else {

                //this.operacionesDMPS();

                let auxiliarCliente = {
                    nombre: this.nombre,
                    imgurl: this.img,
                    direccion: this.direccion,
                    fp: this.fp,
                    representante: this.representante,
                    rut: this.rut,
                    telefono: this.telefono,
                    distribuidora: this.distribuidora,
                    potencia: this.potencia,
                    tarifa: this.tarifa,
                    numerocliente: this.numerocliente,
                    costoCLP_KWh: parseFloat(this.costoCLP_KWh),
                    costoCLP_transporte: parseFloat(this.costoCLP_transporte),
                    precioCLP_excedente: parseFloat(this.precioCLP_excedente),
                    boleta: this.boleta,
                    aporte: this.aporte,
                    estado: 'Propuesta',
                    valordolar: this.$store.state.dolar,
                    imageUrl:this.imageUrl,

                }
                //console.log(auxiliarCliente);
                this.$store.dispatch('grabarCliente', auxiliarCliente)
                this.$refs['my-modal'].hide();

            }
        },
        borraritems(opcion) {
            Swal.fire({
                title: 'Seguro de Borrar TODOS los Items?',
                text: "Se reiniciará la matriz de datos",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si'
            }).then((result) => {
                if (result.value) {
                    if (opcion === 'C') {
                        this.consumo = [];
                        this.sumaelemento1 = 0, this.sumaelemento2 = 0, this.sumaelemento3 = 0, this.sumaelemento4 = 0;
                        this.contador = 1;
                    } else if (opcion === 'A') {
                        this.aporte = [];
                        this.sumaelemento1a = 0;
                        this.contador2 = 1;

                    }
                }
            })
        },
        subir() {
            alert("hola");
        },
        operacionesDMPS() { //  17/092020 para registrar aqui mismo DMPS DMPSHP Y la data 
            //Demanda Maxima de Potencia Suministrada DMPS
            //1) duplicar los consumos para llevar a 24 meses    
            for (let index = 0; index < 12; index++) {
                this.kwtabulado1[index] = this.boleta[index].cargoTarifario_d18; //demanda máxima de potencia leída en horas punta
                //this.kwtabulado2[index] = this.boleta[index].cargoTarifario_d19; //demanda máxima de potencia suministrada
            }

            this.kwtabulado1Doble = this.kwtabulado1.concat(this.kwtabulado1);
            for (let jj = 12; jj < this.kwtabulado1Doble.length; jj++) {
                this.arreglotemporal = []; // se inicia el arreglo vacio
                this.kesimomayor1 = 0 // se inicia el k-mayor1 en cero
                this.kesimomayor2 = 0 // se inicia el k-mayor2 en cero  

                for (let ii = 0; ii < 12; ii++) {
                    // A partir del mes enero del año 2 se consultan 12 meses hacia atras para cada rango de 12 meses Ene hasta Dic
                    //console.log('jj es ' + jj + '  los valores hacia atras son ' + (12 - ii) + ' el valor es ' + this.kwtabulado1Doble[jj - ii]);
                    //2) guardar en un arreglo temporal los 12 valores 
                    this.arreglotemporal.push(this.kwtabulado1Doble[jj - ii]);
                }
                // 3) ordenar de menor a mayor para conocer 4)
                this.arreglotemporal.sort(function (a, b) {
                    return a - b
                });
                // 4) tomar los dos valores mayores 1 y 2
                this.kesimomayor1 = this.arreglotemporal[11];
                this.kesimomayor2 = this.arreglotemporal[10];

                //console.log(this.arreglotemporal);
                //console.log("El k-esimo mayor 1 es " + this.kesimomayor1);
                //console.log("El k-esimo mayor 2 es " + this.kesimomayor2);

                let auxiliarDMPS = {
                    mes: this.mesesIniciales[jj - 12], // mes 1 para enero hasta 12 diciembre
                    mesabrsep: this.mesesabrsep[jj - 12], //cero para ene/feb/mar/oct/nov/dic  1 para abr hasta sept
                    kesimomayor1: this.kesimomayor1,
                    kesimomayor2: this.kesimomayor2
                };

                this.DMPS.push(auxiliarDMPS); // se almacena este arreglo par valor y utilizar en la tabla DMPS  para el calculo                
                //console.log(this.DMPS);
                //alert("pausa ");

            }
            // v-for para inyectar a boleta los valores de DMPS 

            //            console.log(this.DMPS);
        }        
    },

    watch: {
        nombre() {
            this.fpvalores = this.$store.getters.enviarDataFactorPlanta;
            this.distribuidoravalores = this.$store.getters.enviarDataDistribuidora;
            this.tarifavalores = this.$store.getters.enviarDataTarifa;

        }

    }

}
</script>

<style lang="scss" scoped>
.tamano1 {
    font-size: 10px;

}
</style>
